// @flow

import MenuItem from './models';
import moment from "moment";
import {convertBase64ToBlog, saveByteArray} from "../../../../../shared/fileUtils";

/**
 * Flatten the nested list of menu items
 */
let uuid = 1;

const assignIdAndParent = (menuItems: Array<MenuItem>, parentId?: number) => {
    menuItems = menuItems || [];
    menuItems.forEach(item => {
        const id = item.id || uuid;
        uuid += 1;
        item.id = id;
        item.parentId = item.parentId || parentId;
        item.active = false;

        if (typeof item.children !== 'undefined') {
            assignIdAndParent(item.children, id);
        }
    });
};

export default (menuItems: Array<MenuItem>) => {
    assignIdAndParent(menuItems);
    return menuItems;
};

if (!String.prototype.format) {
    String.prototype.format = function () {
        let args = arguments;
        return this.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != 'undefined'
                ? args[number]
                : match
                ;
        });
    };
}

export const formatDate = str => {
    if (!str || str === 'None') {
        // TODO update the message for a little more general
        return 'Not modified';
    }
    return moment.utc(str, 'YYYY/MM/DD HH:mm:ss').local().format('DD/MM/YYYY HH:mm:ss');
};

export const lookupInputValue = (name, inputs) => {
    for (const i of inputs) {
        if (i.name === name) {
            return i.value;
        }
    }
    return null;
};

export const lookupInputIndex = (name, inputs) => {
    return inputs.findIndex(i => i.name === name);
};

export const lookupInputType = (name, inputs) => {
    for (const i of inputs) {
        if (i.name === name) {
            return i.type;
        }
    }
    return null;
};


export const solveDownloadResponse = response => {
    const contentType = response.headers['content-type'];
    const blob = convertBase64ToBlog(response.data, contentType);
    saveByteArray(response.headers['x-file-name'], blob, contentType);
};
